import Notify from 'simple-notify';
import 'simple-notify/dist/simple-notify.min.css';

function notification(text, status) {

    //Lang.setLocale('es');

    var title = "";
    if (status == "error") {
        title = Lang.get('lang.Oups!');
    } else if (status == "success") {
        title = Lang.get('lang.Succès');
        if (text == null) {
            text = Lang.get('lang.Enregistré avec succès');
        }
    }
    new Notify({
        status: status,
        title: title,
        text: text,
        effect: 'fade',
        speed: 300,
        customClass: null,
        customIcon: null,
        showIcon: true,
        showCloseButton: true,
        autoclose: true,
        autotimeout: 3000,
        gap: 20,
        distance: 20,
        type: 1,
        position: 'right top'
    });
}

export { notification };
